import {Component, 
    OnInit, 
    ElementRef, 
    ViewChildren, 
    ViewChild, 
    ChangeDetectionStrategy, 
    ChangeDetectorRef, 
    Inject, 
	ViewRef
} 
from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
// Material
import { MatMenuTrigger, MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
import { CdkDragStart, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
// RXJS
import { ReplaySubject,BehaviorSubject } from 'rxjs';
//Service
import { NhapKhoVer2Service } from '../phieu-nhap-kho-ver2-service/phieu-nhap-kho-ver2.service';
import { SubheaderService } from '../../../../../../core/_base/layout';
import { LayoutUtilsService, MessageType } from '../../../../../../core/_base/crud';
import { TokenStorage } from '../../../../../../core/auth/_services/token-storage.service';
//Model
import { CommonConFig } from 'app/views/pages/nfc/dung-chung/__model/common_config.model';
import { ChiTietPhieuNhapKho, PhieuNhapKho, NguoiThucHienNhapKho } from '../phieu-nhap-kho-ver2-model/phieu-nhap-kho-ver2.model';
import { FormGroup, FormBuilder, Validators} from '@angular/forms';
import { DeNghiNhapKhoChiTiet } from '../../kho-phieu-thong-tin-hang-ve/phieu-thong-tin-hang-ve-ver2-model/phieu-thong-tin-hang-ve-ver2.model';
import moment from 'moment';
import { DungChungService } from '../../../dung-chung/__services/dung-chung.service';

@Component({
	selector: 'm-xac-nhan-nhap-kho',
	templateUrl: './xac-nhan-nhap-kho.component.html',
	styleUrls: ['../phieu-nhap-kho-ver2.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers:[DatePipe]
})

export class XacNhanNhapKhoComponent implements OnInit{

	/*Config Form */
	CONFIG: CommonConFig;
	
    /* Các trường focus cho các tag trong form */
	@ViewChildren('focus') focus ;
	@ViewChildren('focusNCC') focusNCC;
	@ViewChildren('focusQC') focusQC;
	@ViewChildren('focusNVNH') focusNVNH;
	@ViewChildren('focusKho') focusKho;
    @ViewChildren('focusGhiChu') focusGhiChu;

    /* Comment columns mat-table
    Các trường columns cho bảng:
    - displayedColumns: display ra form
    - availableColumns: các cột sẽ được add vào display.
    - extendsColumns: các cột mở rộng thêm cho display khi QC kiểm tra
	*/
	displayedColumns = [];
	availableColumns = [
        {
			stt: 1,
			name: '#',
			displayName: '#',
			alwaysChecked: false,
			isShow: true
        },
        {
            stt: 2,
            name: 'MaHH',
            displayName: 'Mã hàng',
            alwaysChecked: false,
			isShow: true
        },
        {
            stt: 3,
            name: 'TenHH',
            displayName: 'Tên hàng',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 4,
            name: 'QuyCach',
            displayName: 'Quy cách',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 5,
            name: 'TenDVT',
            displayName: 'ĐVT',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 6,
            name: 'Soluongthucnhap',
            displayName: 'SL',
            alwaysChecked: false,
			isShow: true
		},
        {
            stt: 7,
            name: 'Solo',
            displayName: 'Số lô',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 8,
            name: 'Handung',
            displayName: 'Hạn sử dụng',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 9,
            name: 'IdKho',
            displayName: 'Kho',
            alwaysChecked: false,
			isShow: true
        },
		{
            stt: 10,
            name: 'ViTriKho',
            displayName: 'Vị trí kho',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 11,
            name: 'Tinhtrang',
            displayName: 'Cho phép xuất kho',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 12,
            name: 'Phieukiemtracl',
            displayName: 'Số phiếu KTHH',
            alwaysChecked: false,
			isShow: true
        }
	];
	tmpAvailableColumns = [
        {
			stt: 1,
			name: '#',
			displayName: '#',
			alwaysChecked: false,
			isShow: true
        },
        {
            stt: 2,
            name: 'MaHH',
            displayName: 'Mã hàng',
            alwaysChecked: false,
			isShow: true
        },
        {
            stt: 3,
            name: 'TenHH',
            displayName: 'Tên hàng',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 4,
            name: 'QuyCach',
            displayName: 'Quy cách',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 5,
            name: 'TenDVT',
            displayName: 'ĐVT',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 6,
            name: 'Soluongthucnhap',
            displayName: 'SL',
            alwaysChecked: false,
			isShow: true
		},
        {
            stt: 7,
            name: 'Solo',
            displayName: 'Số lô',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 8,
            name: 'Handung',
            displayName: 'Hạn sử dụng',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 9,
            name: 'IdKho',
            displayName: 'Kho',
            alwaysChecked: false,
			isShow: true
        },
		{
            stt: 10,
            name: 'ViTriKho',
            displayName: 'Vị trí kho',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 11,
            name: 'Tinhtrang',
            displayName: 'Cho phép xuất kho',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 12,
            name: 'Phieukiemtracl',
            displayName: 'Số phiếu KTHH',
            alwaysChecked: false,
			isShow: true
        },
	];
	phieuTTHVColumn = [
        {
			stt: 1,
			name: '#',
			displayName: '#',
			alwaysChecked: false,
			isShow: true
        },
        {
            stt: 2,
            name: 'MaHH',
            displayName: 'Mã hàng',
            alwaysChecked: false,
			isShow: true
        },
        {
            stt: 3,
            name: 'TenHH',
            displayName: 'Tên hàng',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 4,
            name: 'QuyCach',
            displayName: 'Quy cách',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 5,
            name: 'TenDVT',
            displayName: 'ĐVT',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 6,
            name: 'SoPhieuDN',
            displayName: 'Số phiếu TTHV',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 7,
            name: 'Soluongchungtu',
            displayName: 'SLCT',
            alwaysChecked: false,
			isShow: true
		},

		{
            stt: 8,
            name: 'Soluongthucnhap',
            displayName: 'SL',
            alwaysChecked: false,
			isShow: true
		},
        {
            stt: 9,
            name: 'Solo',
            displayName: 'Số lô',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 10,
            name: 'Handung',
            displayName: 'Hạn sử dụng',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 11,
            name: 'IdKho',
            displayName: 'Kho',
            alwaysChecked: false,
			isShow: true
        },
		{
            stt: 12,
            name: 'ViTriKho',
            displayName: 'Vị trí kho',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 13,
            name: 'Tinhtrang',
            displayName: 'Cho phép xuất kho',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 14,
            name: 'Phieukiemtracl',
            displayName: 'Số phiếu KTHH',
            alwaysChecked: false,
			isShow: true
        }
	];
	ketQuaSXColumn = [
        {
			stt: 1,
			name: '#',
			displayName: '#',
			alwaysChecked: false,
			isShow: true
        },
        {
            stt: 2,
            name: 'MaHH',
            displayName: 'Mã hàng',
            alwaysChecked: false,
			isShow: true
        },
        {
            stt: 3,
            name: 'TenHH',
            displayName: 'Tên hàng',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 4,
            name: 'QuyCach',
            displayName: 'Quy cách',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 5,
            name: 'TenDVT',
            displayName: 'ĐVT',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 6,
            name: 'LenhSX',
            displayName: 'Lệnh SX',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 7,
            name: 'Soluongkh',
            displayName: 'SLKH',
            alwaysChecked: false,
			isShow: true
		},

		{
            stt: 8,
            name: 'Soluongthucnhap',
            displayName: 'SL',
            alwaysChecked: false,
			isShow: true
		},
        {
            stt: 9,
            name: 'Solo',
            displayName: 'Số lô',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 10,
            name: 'Handung',
            displayName: 'Hạn sử dụng',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 11,
            name: 'IdKho',
            displayName: 'Kho',
            alwaysChecked: false,
			isShow: true
        },
		{
            stt: 12,
            name: 'ViTriKho',
            displayName: 'Vị trí kho',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 13,
            name: 'Tinhtrang',
            displayName: 'Cho phép xuất kho',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 14,
            name: 'Phieukiemtracl',
            displayName: 'Số phiếu KTHH',
            alwaysChecked: false,
			isShow: true
        }
	];
	phieuDNNKColumn = [
        {
			stt: 1,
			name: '#',
			displayName: '#',
			alwaysChecked: false,
			isShow: true
        },
        {
            stt: 2,
            name: 'MaHH',
            displayName: 'Mã hàng',
            alwaysChecked: false,
			isShow: true
        },
        {
            stt: 3,
            name: 'TenHH',
            displayName: 'Tên hàng',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 4,
            name: 'QuyCach',
            displayName: 'Quy cách',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 5,
            name: 'TenDVT',
            displayName: 'ĐVT',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 6,
            name: 'SoPhieuDNNK',
            displayName: 'Số phiếu ĐNNK',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 7,
            name: 'SoluongchungtuDNNK',
            displayName: 'SLĐN',
            alwaysChecked: false,
			isShow: true
		},

		{
            stt: 8,
            name: 'Soluongthucnhap',
            displayName: 'SL',
            alwaysChecked: false,
			isShow: true
		},
        {
            stt: 9,
            name: 'Solo',
            displayName: 'Số lô',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 10,
            name: 'Handung',
            displayName: 'Hạn sử dụng',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 11,
            name: 'IdKho',
            displayName: 'Kho',
            alwaysChecked: false,
			isShow: true
        },
		{
            stt: 12,
            name: 'ViTriKho',
            displayName: 'Vị trí kho',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 13,
            name: 'Tinhtrang',
            displayName: 'Cho phép xuất kho',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 14,
            name: 'Phieukiemtracl',
            displayName: 'Số phiếu KTHH',
            alwaysChecked: false,
			isShow: true
        }
	];

    /* Mat select search cho hàng hóa */
	listId_HH : any[] = [];
	selectId_HH : string = '';
	filteredId_HH: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	Id_HHFilterCtrl: string = '';
	haveElementId_HH: boolean = false;
	/* ------------------------------------------------------------------ */
    
    /* Mat select search cho nhân viên nhận hàng - QC kiểm tra */
	listIdNV : any[] = [];
	selectIdNV : string = '';
	filteredIdNV: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	IdNVFilterCtrl: string = '';
	haveElementIdNV: boolean = false;
	/* ------------------------------------------------------------------ */

    /* Mat select search cho kho */
	listKho : any[] = [];
	selectKho : string = '';
	filteredKho: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	KhoFilterCtrl: string = '';
	haveElementKho: boolean = false;
	arrayKhoForEachHH: any[] = [];

	listKhoVer2 : any[] = [];
	selectKhoVer2 : string = '';
	filteredKhoVer2: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	KhoFilterCtrlVer2: string = '';
	haveElementKhoVer2: boolean = false;
	/* ------------------------------------------------------------------ */

	/* Mat select search cho vị trí kho */
	SaveListVTK: any[] = [];
	selectVTKho : string = '';
	filteredVTKho: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	VTKhoFilterCtrl: string = '';
	arrayVTKhoForEachHH: any[] = [];

	ListVTKVer2: any[] = [];
	selectVTKhoVer2: string = '';
	filteredVTKhoVer2: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	VTKhoFilterCtrlVer2: string = '';
	/* ------------------------------------------------------------------ */
	
    /* Danh sách trạng thái */
	listState : any[] = [];
	nameState: string = '';
    /* ------------------------------------------------------------------ */
    
    /* Selection */
	selectedColumns = new SelectionModel<any>(true, this.availableColumns);
	selection = new SelectionModel<ChiTietPhieuNhapKho>(true, []);
    /* ------------------------------------------------------------------ */
    
    /* Loading.... */
	loadingSubject = new BehaviorSubject<boolean>(false);
	loading$ = this.loadingSubject.asObservable();
    /* ------------------------------------------------------------------ */
    
    /* Extend field:  */
	previousIndex: number; 				// Lưu lại vị trí trước đó khi swap các cột trên lưới
	fixedPoint = 2;                		// Số chữ số phần thập phân cho kiểu dữ liệu số.
	isChange: boolean = false;			// Trường kiểm tra dialog có cập nhập - thay đổi dữ liệu hay không
	isZoomSize: boolean = false;    	// Trường đánh dấu có đang ở trạng thái zoom size hay không
	saveAddedNK: number[] = []		    // Save ID các record đã thay đổi để đánh dấu highlight trên list khi đóng dialog
	viewLoading: boolean = false;   	// Loading khi mở dialog
	canEdit: boolean = true;			// Dialog có thể chỉnh sửa không?
    disableNewButton: boolean = true;	// Tắt nút thêm mới hàng khi chưa nhập đủ
	listNguoiThucHien: string[] = [];   // Array lưu id người thực hiện
    /* ------------------------------------------------------------------ */

     /* Các Sub form trên dialog:  */
	NKForm: FormGroup;				        //Form thông tin nhập kho
    hasFormErrors: boolean = false;
    
    DuyetForm:FormGroup;				    //Form thông tin duyệt
    /* ------------------------------------------------------------------ */
    
    /* Item dữ liệu từ của phiếu đề nghị khi mở dialog:  */
    NKItem: PhieuNhapKho;

    /* Danh sách chi tiết hàng hóa của phiếu nhập kho:   */
    listChiTietNK: ChiTietPhieuNhapKho[] = [];
    
    /* Danh sách tạm chi tiết hàng hóa của phiếu nhập kho */
	tmpChiTietNK: ChiTietPhieuNhapKho[] = [];
	
	/* Danh sách tạm chi tiết đề nghị nhập kho để so sánh khi nhập số lượng trên lưới */
	deNghiNhapKhoResult: DeNghiNhapKhoChiTiet[] = [];
	
	optionsTinhTrang = [
		{
			id: 1,
			name: 'Đang soạn thảo',
			value: 'NK_PHIEUMOI',
		},
		{
			id: 2,
			name: 'Chờ xác nhận',
			value: 'NK_CHOXACNHAN',
		},
		{
			id: 3,
			name: 'Từ chối',
			value: 'NK_TUCHOI',
		},
		{
			id: 4,
			name: 'Đã hủy',
			value: 'NK_DAHUY',
		},
		{
			id: 5,
			name: 'Hoàn tất',
			value: 'NK_HOANTAT',
		}
	];

    constructor(
		public dialogRef: MatDialogRef<XacNhanNhapKhoComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private nhapKhoService: NhapKhoVer2Service,
        private NKFB: FormBuilder,
        private DuyetFB: FormBuilder,
		private route: ActivatedRoute,
		public dialog: MatDialog,
		private router: Router,
		private datePipe: DatePipe,
		private tokenStorage: TokenStorage,
		private translate: TranslateService,
		private subheaderService: SubheaderService,
		private changeDetect: ChangeDetectorRef,
		private layoutUtilsService: LayoutUtilsService,
		private el: ElementRef,
		private dungChungService: DungChungService,
    ) { 
		this.dialogRef.disableClose = true;
    }
    
    /** LOAD DATA */
	ngOnInit() {
		
		/*Load cấu hình config form */
		this.CONFIG = new CommonConFig();

		/*Get data from list when open dialog */
		this.NKItem = this.data.data;

		/*Load all dropdown and create form */
		this.ListState();
		this.ListId_HH();
		this.createForm();

		/*Handel keydown event in dialog*/
		this.dialogRef.keydownEvents().subscribe(event => {
			if (event.key == "Escape") {
				this.back();
			}
			if (event.altKey && event.keyCode == 82) {
				this.onSubmit(1);
			}
			if (event.altKey && event.keyCode == 88) {
				this.onSubmit(2);
			}
			this.changeDetect.detectChanges();
        });
        
        if(this.NKForm.controls['LoaiPhieu'].value == 'Nhập kho hàng NCC giao'){
			this.availableColumns = this.phieuTTHVColumn
		}
		else if(this.NKForm.controls['LoaiPhieu'].value == 'Nhập kho từ kết quả sản xuất'){
			this.availableColumns = this.ketQuaSXColumn
		}
		else if(this.NKForm.controls['LoaiPhieu'].value == 'Nhập kho hàng đề nghị'){
			this.availableColumns = this.phieuDNNKColumn
		}
		else{
			this.availableColumns = this.tmpAvailableColumns
		}
		this.selectedColumns = new SelectionModel<any>(true, this.availableColumns);
        
		/*Show column */
		this.showColumnsInTable();
		this.applySelectedColumns();
    }

    /*Create Form with appropriate sub forms */
	createForm(){
		/*Get name of người lập phiếu */
		var tenNguoiLap = '';
		this.tokenStorage.getFullName().subscribe(t => { tenNguoiLap = t; });

		var idUser = '';
		this.tokenStorage.getIDUser().subscribe(t => { idUser = t; });
		this.NKItem.Nguoitao = +idUser;
	
		let listName = '';
		if(this.NKItem.IdNk > 0){
			this.NKItem.listNguoiThucHien.forEach(element =>{
				listName += element.TenNguoiThucHien + ', ';
			})
		}
		listName = listName.substring(0, listName.length - 2);

		/*Group các Form */
		this.NKForm = this.NKFB.group({
			SoPhieu: [!(this.NKItem.Sophieu == undefined || this.NKItem.Sophieu == '') ? this.NKItem.Sophieu : '', Validators.required],
			NgayLapPhieu: [!(this.NKItem.Ngaytao == undefined || this.NKItem.Ngaytao == '') ? this.NKItem.Ngaytao : new Date(), Validators.required],
			TenNguoiLap: [this.NKItem.IdNk > 0 ? this.NKItem.TenNguoitao : tenNguoiLap],
            TrangThai: [this.nameState],
            LoaiPhieu: [!(this.NKItem.LoaiPhieu == undefined || this.NKItem.LoaiPhieu == '')? this.NKItem.LoaiPhieu : 'Nhập kho hàng NCC giao', Validators.required],
            NgayNhapKho: [!(this.NKItem.Ngaynhapkho == undefined || this.NKItem.Ngaynhapkho == '') ? this.NKItem.Ngaynhapkho : new Date(), Validators.required],
            DSNguoiThucHien: [listName,Validators.required],
            DienGiai: [!(this.NKItem.DienGiai == undefined || this.NKItem.DienGiai == '') ? this.NKItem.DienGiai : '']
		});
		/*Disable các trường dữ liệu không thay đổi */
        this.NKForm.disable();
        /*------------------------------------------------------------------*/

        this.DuyetForm = this.DuyetFB.group({
            NguoiXacNhan: [tenNguoiLap],
            NgayXacNhan: [this.getFormatDate(moment(new Date()).format('YYYY-MM-DD[T]HH:mm:ss.SSS'))],
            LyDo: ['']
        })
        this.DuyetForm.controls["NguoiXacNhan"].disable();
        this.DuyetForm.controls["NgayXacNhan"].disable();
        /*------------------------------------------------------------------*/

		/*Add dữ liệu chi tiết*/
		if(this.NKItem.listChiTietPhieuNhapKho.length > 0){
			this.listChiTietNK = this.NKItem.listChiTietPhieuNhapKho;
			this.tmpChiTietNK = [];
			for(let i = 0; i < this.listChiTietNK.length; i++){
				let tmpElement = new ChiTietPhieuNhapKho();
				tmpElement.copy(this.listChiTietNK[i])
				this.tmpChiTietNK.push(tmpElement);
			}
	
			this.tmpChiTietNK = [...this.tmpChiTietNK];
        }
		
        this.changeDetect.detectChanges();
    }
    
    /*Hàm thông báo lỗi cho form tương ứng */
	onAlertFormClose($event) {
		this.hasFormErrors = false;
	}
    /*---------------------------------------- */
    
    /*Lấy tiêu đề cho dialog*/
	getTitle(): string {
		return `Xác nhận phiếu nhập kho`;
    }
    
    /*Các hàm hỗ trợ hiển thị các cột và chuyển cột trong bảng*/
    showColumnsInTable(){
		for(let i = 0; i < this.availableColumns.length; i++){
			if(this.availableColumns[i].isShow == false){
				this.selectedColumns.toggle(this.availableColumns[i]);
			}
		}
	}
	findIndexColumn(column: string){
		for( let i = 0; i < this.availableColumns.length; i++){
			if(this.availableColumns[i].name == column)
				return i;
		}
	}
	dragStarted(event: CdkDragStart, column: string) {
		this.previousIndex = this.findIndexColumn(column);
	}
	dropListDropped(event: CdkDropList, column: string) {
		if (event) {
			moveItemInArray(this.availableColumns, this.previousIndex, this.findIndexColumn(column));
			this.applySelectedColumns();
		}
	}
	applySelectedColumns() {
		let _selectedColumns = this.selectedColumns.selected;
		this.selectedColumns = new SelectionModel<any>(true, this.availableColumns);
		for(let i = 0; i < this.availableColumns.length; i++){
			this.selectedColumns.toggle(this.availableColumns[i]);
			for( let j = 0; j < _selectedColumns.length; j++){
				if( this.availableColumns[i].name == _selectedColumns[j].name){
					this.selectedColumns.toggle(this.availableColumns[i]);
					break;
				}
			}
		}
		const _applySelectedColumns: string[] = [];
		this.selectedColumns.selected.forEach(col => { _applySelectedColumns.push(col.name) });
		this.displayedColumns = _applySelectedColumns;
	}
	changeValueOfColumn(columnName:string, item:any, event: any, afterUpdate: boolean, index: number){
		
		if(columnName == 'Soluongthucnhap'){
			if(afterUpdate)
				this.tmpChiTietNK[this.tmpChiTietNK.indexOf(item)].Soluongthucnhap = this.formatNumber(item.Soluongthucnhap);
			else if(!afterUpdate ){
				let indexOfItem = this.tmpChiTietNK.indexOf(item);				
				let _index = this.deNghiNhapKhoResult.findIndex(x => x.IdHh == this.tmpChiTietNK[indexOfItem].IdHh 
																	&& x.IdKho == this.tmpChiTietNK[indexOfItem].IdKho
																	&& x.Solo == this.tmpChiTietNK[indexOfItem].Solo
																	&& x.Handung == this.tmpChiTietNK[indexOfItem].Handung)

				let cal = Number(event.target.value.trim());
				if(!Number.isNaN(cal) && _index > -1 && Number(this.deNghiNhapKhoResult[_index].Soluongchungtu) < cal){
					this.layoutUtilsService.showErorr('Số lượng nhập không thể lớn hơn số lượng hàng về');
					return null;
				}
				else{
					this.tmpChiTietNK[this.tmpChiTietNK.indexOf(item)].Soluongthucnhap = event.target.value.trim();
					this.afterChangeRecord(item,index)
				}
			}
		}
		else if(columnName == 'Solo'){
			if(afterUpdate)
				this.listChiTietNK[this.tmpChiTietNK.indexOf(item)].Solo = item.Solo
			else if(!afterUpdate){
				this.tmpChiTietNK[this.tmpChiTietNK.indexOf(item)].Solo = event.target.value.trim();
				this.afterChangeRecord(item,index)
			}
		}
		else if(columnName == 'Phieukiemtracl'){
			if(afterUpdate)
				this.listChiTietNK[this.tmpChiTietNK.indexOf(item)].Phieukiemtracl = item.Phieukiemtracl
			else if(!afterUpdate){
				this.tmpChiTietNK[this.tmpChiTietNK.indexOf(item)].Phieukiemtracl = event.target.value.trim();
				this.afterChangeRecord(item,index)
			}
		}
	}
	afterChangeRecord(item:ChiTietPhieuNhapKho, index: number){
		
		let isContain = false;
		for(let i = 0; i < this.tmpChiTietNK.length; i++){
			if(index != i && item.IdHh == this.tmpChiTietNK[i].IdHh 
				&& item.IdKho == this.tmpChiTietNK[i].IdKho
				&& item.Solo == this.tmpChiTietNK[i].Solo
				&& this.getFormatDate(item.Handung) == this.getFormatDate(this.tmpChiTietNK[i].Handung)
				&& item.ViTriKho == this.tmpChiTietNK[i].ViTriKho){
					this.tmpChiTietNK[i].Soluongthucnhap = '' + (Number(item.Soluongthucnhap) 
														+ Number(this.tmpChiTietNK[i].Soluongthucnhap));
					isContain = true;
					break;
			}
		}
		if(isContain){
			this.tmpChiTietNK.splice(index, 1);
			this.arrayKhoForEachHH.splice(index, 1);
			this.arrayVTKhoForEachHH.splice(index, 1);
			this.SaveListVTK.splice(index, 1);

			this.tmpChiTietNK = [...this.tmpChiTietNK];
			this.changeDetectView();
		}
	}
    /*---------------------------------------------------------------------------------------- */
    
    /*Hàm lấy danh sách trạng thái phiếu*/
	ListState(){
		this.dungChungService.listState(PhieuNhapKho.category_path).subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listState = res.data;
				this.checkState();
				this.changeDetect.detectChanges();
			};
		});
	}
	checkState(){
		this.listState.forEach(element => {
			if(element.Code == this.NKItem.Tinhtrang){
				this.nameState = element.Description;
				if(this.NKForm != null)
					this.NKForm.controls["TrangThai"].setValue(this.nameState);
			}
		});
	}
	/*---------------------------------------- */
	
	/*Các hàm hỗ trợ cho mat select search Hàng hóa*/
	ListId_HH(){
		this.dungChungService.listHangHoa().subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listId_HH = res.data;
				this.filteredId_HH.next(this.listId_HH.slice());
				this.changeDetectView();
			};
		});
	}
	checkCanPhieuKT(idHH: any){
		
		let index = this.listId_HH.findIndex(x => x.Id_HH == idHH)
		if(index > -1 && this.listId_HH[index].CanPhieuKT != null 
			&& this.listId_HH[index].CanPhieuKT != undefined && !this.listId_HH[index].CanPhieuKT){
			return true;
		}
		return false;
	}
	/*------------------------------------------ */
    
    /*Hàm hỗ trợ format các dạng số trên form*/
	ValidateChangeNumberForm(event: any, isEvent:boolean = true) {
		var count = 0;
		if(isEvent){
			for(let i = 0; i < event.target.value.length; i++){
				if(event.target.value[i] == '.'){
					count += 1;
				}
			}
		}
		else{
			event = "" + event
			for(let i = 0; i < event.length; i++){
				if(event[i] == '.'){
					count += 1;
				}
			}
		}
		;
		var regex = this.CONFIG.REGEX_SPECIAL_CHARACTER;
		var found = isEvent ? event.target.value.match(regex) : event.match(regex);
		if (found != null) {
			const message = 'Số lượng không gồm chữ hoặc kí tự đặc biệt';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		if (count >= 2) {
			const message = 'Số lượng không thể có nhiều hơn 2 dấu .';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		return true;
	}
	formatNumber(item: string){
		if(item == '' || item == null || item == undefined)	return '';
		return Number(Math.round(parseFloat(item + 'e' + this.fixedPoint)) + 'e-'+ this.fixedPoint).toFixed(this.fixedPoint)
	}
	f_currency(value: string): any {
		if (value == null || value == undefined || value == '') value = '0.00';
		let nbr = Number((value.substring(0,value.length - (this.fixedPoint + 1)) + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + value.substr(value.length - (this.fixedPoint + 1),(this.fixedPoint + 1));
	}
	f_currency_V2(value: string): any {
		if (value == null || value == undefined || value == '') return '';
		let nbr = Number((value + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
	}
	lpad(value, padding) {
		var zeroes = new Array(padding+1).join("0");
		return (zeroes + value).slice(-padding);
	}
	/*------------------------------------------------------------- */

	/*Hàm hỗ trợ format các dạng ngày trên form*/
	getFormatDate(v: string = '') {
        if (v != '') {
            return v.includes('T') ? v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})(T)(\d{2})(:)(\d{2})(:)(\d{2}).*$/g, "$5/$3/$1") : v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})/g, "$5/$3/$1");
        }
        return '';
	}
	f_convertDate(p_Val: any) {
		if(p_Val == null || p_Val == undefined || p_Val == '') return '';
		let a = p_Val === "" ? new Date() : new Date(p_Val);
		return ("0" + (a.getDate())).slice(-2) + "/" + ("0" + (a.getMonth() + 1)).slice(-2) + "/" + a.getFullYear();
	}
	minMaxDate(p_Val: any, item: any) {
		
		let d1 = new Date(p_Val);
		let d2 = new Date();

		if (d1.getTime() < d2.getTime()){
			this.tmpChiTietNK[this.tmpChiTietNK.indexOf(item)].Handung =  moment(new Date()).format('YYYY-MM-DD[T]HH:mm:ss.SSS');
			this.tmpChiTietNK = [...this.tmpChiTietNK];
		}
		this.changeDetect.detectChanges();
	}
    /*------------------------------------------------------------- */

    /*Xác nhận phiếu nhập kho */
    onSubmit(type: number) {
		for(let i = 0; i < this.tmpChiTietNK.length; i++){
			if(!this.tmpChiTietNK[i].isError){
				if(!this.checkCanPhieuKT(this.tmpChiTietNK[i].IdHh) && this.tmpChiTietNK[i].Tinhtrang 
						&& (this.tmpChiTietNK[i].Phieukiemtracl == null || this.tmpChiTietNK[i].Phieukiemtracl == '')){
					this.layoutUtilsService.showErorr('Vui lòng nhập số phiếu KTHH cho mã hàng ' + this.tmpChiTietNK[i].MaHH);
					return null;
				}
			}
		}
		this.NKItem.listChiTietPhieuNhapKho = this.tmpChiTietNK;

		let tmpTinhTrang = '';
        const controls = this.DuyetForm.controls;
        
        if(type == 1){
            if(controls["LyDo"].value == null || controls["LyDo"].value == ''){
				this.layoutUtilsService.showErorr('Vui lòng nhập lý do từ chối');
                this.focus.first.nativeElement.focus();
                return null;
            }
            tmpTinhTrang = this.optionsTinhTrang[2].value;
        }
        else if(type == 2){
            tmpTinhTrang = this.optionsTinhTrang[4].value;
        }
        this.NKItem.LyDo = controls["LyDo"].value;

		let dialogRef;
		if(type == 1)
			dialogRef = this.layoutUtilsService.POP03(this.NKItem.Sophieu);
		else if(type == 2)
			dialogRef = this.layoutUtilsService.POP02(this.NKItem.Sophieu);
     
		dialogRef.afterClosed().subscribe(res => {
			if (!res) {
				return;
			}
			if(tmpTinhTrang == '') return null;
			this.NKItem.Tinhtrang = tmpTinhTrang;
			
			this.nhapKhoService.updateHHState(this.NKItem).subscribe(res => {
				if (res.status == 1){
					this.nhapKhoService.duyet(this.NKItem).subscribe(resConfirm => {
						if (resConfirm.status == 1) {		
							this.layoutUtilsService.showInfo('Cập nhập thành công');
							this.saveAddedNK.push(res.data.IdNk);
							this.isChange = true;
							this.back();
						}
						else {
							this.NKItem.Tinhtrang = this.optionsTinhTrang[1].value;
							this.layoutUtilsService.showErorr(res.error.message);
						}
					});
				}
				else{
					this.NKItem.Tinhtrang = this.optionsTinhTrang[1].value;
					this.layoutUtilsService.showErorr(res.error.message);
				}
			});
            
			
		});
	}
	valueCheckboxChange(index:number, event: any){
		if(event != null && event != undefined)
			this.tmpChiTietNK[index].Tinhtrang = event.checked;
	}
    /*------------------------------------------------------------- */
    
    /*Đóng dialog và cập nhập lại tình trạng, trả về highlight ID nếu có*/
	back(){
		this.dialogRef.close(
			{ 
				isChange: this.isChange,		//Dữ liệu có thay đổi hay không?
				dataAdd : this.saveAddedNK,
			}
		);
	}
	/*------------------------------------------------------------- */

	/*
		Hàm hỗ trợ tổ hợp phím trên form
	*/
	onKeydownMain(event :KeyboardEvent) {
		//Tham khảo keyCode của event theo link: https://www.cambiaresearch.com/articles/15/javascript-char-codes-key-codes
	}
	focusEvent(){
		if(this.focus != null && this.focus != undefined){
			setTimeout(() => this.focus.first.nativeElement.focus(), 500);
			this.changeDetect.detectChanges();
		}
	}
	changeDetectView(){
		if (!(this.changeDetect as ViewRef).destroyed) {
			this.changeDetect.detectChanges()
		}
	}
	/*------------------------------------------------------------- */
}